import { Component, inject, input, output } from '@angular/core';
import { MenuService } from '../../../core/services/menu.service';
import { SidebarMenuItemComponent } from '../sidebar-menu-item/sidebar-menu-item.component';
import { SyncStatusComponent } from '../sync-status/sync-status.component';

/**
 * Sidebar recolhível agrupada. Os itens vêm exclusivamente de
 * MenuService.groups() — nunca decidir visibilidade de item aqui.
 */
@Component({
  selector: 'app-sidebar',
  standalone: true,
  imports: [SidebarMenuItemComponent, SyncStatusComponent],
  templateUrl: './sidebar.component.html',
  styleUrl: './sidebar.component.scss',
})
export class SidebarComponent {
  private readonly menuService = inject(MenuService);

  readonly collapsed = input<boolean>(false);
  /** Emitido quando um item de menu é selecionado — usado para fechar o drawer mobile. */
  readonly itemSelected = output<void>();

  readonly groups = this.menuService.groups;

  onItemClick(): void {
    this.itemSelected.emit();
  }
}
